import { createSelector } from '@ngrx/store';
import { getErrorState } from '../store/store.selectors';
import { ErrorStateInterface } from './error.state';

export const getLatestError = createSelector(
  getErrorState,
  (state: ErrorStateInterface) => state.latestError
);
